import { useEffect, useRef } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { toast } from 'sonner'
import { useAppStore } from '@/store'
import { useTranslation } from '@/i18n'
import { trackEvent } from '@/utils/analytics'

const MSTeamsCallback = () => {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const linkMSTeamsAccount = useAppStore((state) => state.linkMSTeamsAccount)
  const hasLinkedRef = useRef(false)
  
  // Extract code from searchParams to avoid referential instability
  const code = searchParams.get('code')

  useEffect(() => {
    if (hasLinkedRef.current) return

    if (!code) {
      toast.error(t('common:ms_teams.callback.error'))
      navigate('/intelligent-board', { replace: true })
      return
    }

    hasLinkedRef.current = true
    const redirectUri = `${window.location.origin}/auth/callback/ms-teams`

    linkMSTeamsAccount(code, redirectUri)
      .then(() => {
        trackEvent('meeting-integration_linked', { platform: 'ms_teams' })
        toast.success(t('common:ms_teams.callback.success'))
        navigate('/intelligent-board', { replace: true })
      })
      .catch((error) => {
        console.error('Error linking MS Teams account:', error)
        toast.error(t('common:ms_teams.callback.error'))
        navigate('/intelligent-board', { replace: true })
      })
  }, [code, linkMSTeamsAccount, navigate, t])

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        {t('common:settings.meeting_integrations.linking')}
      </div>
    </div>
  )
}

export default MSTeamsCallback

